import { BASE_URL, request } from "./api";
import type { MedicalReference } from "./types";

// GET /api/MedicalReferences
export const getMedicalReferences = async (): Promise<MedicalReference[]> => {
  return request<MedicalReference[]>(`${BASE_URL}/api/MedicalReferences`, {
    method: "GET",
  });
};

// GET /api/MedicalReferences/patient/{patientId}
export const getMedicalReferencesByPatient = async (
  patientId: number
): Promise<MedicalReference[]> => {
  return request<MedicalReference[]>(
    `${BASE_URL}/api/MedicalReferences/patient/${patientId}`,
    { method: "GET" }
  );
};

// POST /api/MedicalReferences
export const createMedicalReference = async (
  medicalReference: MedicalReference
): Promise<MedicalReference> => {
  return request<MedicalReference>(`${BASE_URL}/api/MedicalReferences`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: medicalReference,
  });
};

// GET /api/MedicalReferences/{id}
export const getMedicalReference = async (
  id: number
): Promise<MedicalReference> => {
  return request<MedicalReference>(`${BASE_URL}/api/MedicalReferences/${id}`, {
    method: "GET",
  });
};

// PUT /api/MedicalReferences/{id}
export const updateMedicalReference = async (
  id: number,
  medicalReference: MedicalReference
): Promise<MedicalReference> => {
  return request<MedicalReference>(`${BASE_URL}/api/MedicalReferences/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: medicalReference,
  });
};

// DELETE /api/MedicalReferences/{id}
export const deleteMedicalReference = async (id: number): Promise<void> => {
  return request<void>(`${BASE_URL}/api/MedicalReferences/${id}`, {
    method: "DELETE",
  });
};

export const getAllMedicalReferences = getMedicalReferences;
